import type { FAQItem } from '~/apps/product-plus/components/FAQ';

export const PREMIUM_FEATURES = [
  {
    title: 'Unlimited Grids',
    description: 'Unlock unlimited comparison grids for over 500 sporting events daily',
  },
  {
    title: 'AI Probabilities on Grids',
    description: 'Visibility of our cutting edge AI probabilities on supported sporting events and markets',
  },
  {
    title: 'Market Movers',
    description: 'Unlock unlimited access to the top steamers and drifters daily',
  },
  {
    title: 'Reduced Ads',
    description: 'Never see banner advertising or popups again',
  },
  {
    title: 'Price History',
    description: 'Get unlimited access to price history across 25+ bookmakers',
  },
  {
    title: 'Free Racehorse Share',
    description: 'Claim an exclusive FREE racehorse share worth £40!',
  },
  {
    title: 'Premium Content',
    description: 'Unlock exclusive access to Andy Holding, Ginger Joe, Liam Firkin & more',
  },
  {
    title: '60% off RacingTV',
    description:
      'Get an exclusive 60% off RacingTV subscription at £11.99 per month for 12 months. Available to new and returning RacingTV customers',
  },
  {
    title: 'Value Bets',
    description: 'Get access to our Value Bets tool powered by cutting edge AI',
  },
  {
    title: 'Trends',
    description: 'Identify the best betting opportunities with our AI powered Trends',
  },
  {
    title: 'Public Betting Splits',
    description: 'Get access to where the smart money is going',
  },
];

export const ESSENTIAL_FEATURES = [
  {
    title: 'Unlimited Grids',
    description: 'Unlock unlimited comparison grids for over 500 sporting events daily',
  },
  {
    title: 'Market Movers',
    description: 'Unlock unlimited access to the top steamers and drifters daily',
  },
  {
    title: 'Reduced Ads',
    description: 'Never see banner advertising or popups again',
  },
  {
    title: 'Price History',
    description: 'Get unlimited access to price history across 25+ bookmakers',
  },
  {
    title: 'Free Racehorse Share',
    description: 'Claim an exclusive FREE racehorse share worth £40!',
  },
  {
    title: 'Premium Content',
    isDisabled: true,
  },
  {
    title: '60% off RacingTV',
    isDisabled: true,
  },
  {
    title: 'Value Bets',
    isDisabled: true,
  },
  {
    title: 'Trends',
    isDisabled: true,
  },
  {
    title: 'Public Betting Splits',
    isDisabled: true,
  },
];

export const FAQ_ITEMS: FAQItem[] = [
  {
    heading: 'Do I need an Oddschecker account to get Oddschecker+?',
    content: [
      'Yes, you’ll join Oddschecker for free when signing up to Oddschecker+ and choose between the two tiers of Essential and Premium. If you already have an Oddschecker account, you’ll be prompted to login before making payment.',
    ],
  },
  {
    heading: 'How does the RacingTV promotion work?',
    content: [
      'Available to new and returning customers to RacingTV, Oddschecker+ Premium customers are entitled to 60% off RacingTV for 12 months. Once you’ve signed up for Oddschecker+ Premium, you will receive an exclusive sign up link via email to redeem this offer on the RacingTV website with no promo code required.',
    ],
  },
  {
    heading: 'Why should I sign up to Oddschecker+ Premium?',
    content: [
      'When signing up to Oddschecker+ Premium you will gain access to Andy Holding’s daily column, Ginger Joe covering racing and golf, Liam Firkin and Racing Lee. As well as an early look at next week’s golf tournaments from Niall Lyons. Unlimited access to all other tipster content is available in Oddschecker+ Essential.',
      '60% off RacingTV for 12 months (worth £215) is available to Oddschecker+ Premium subscribers covering British & IRL races from 61 racecourses, including the Cheltenham Festival.',
      'Also included in Premium is access to our brand new betting tools powered by AI. These are Value Bets, Trends and Public Betting Splits, helping you get the edge over the bookmakers.',
    ],
  },
  {
    heading: 'How do I switch between Oddschecker+ Premium and Essential?',
    content: [
      <>
        You can upgrade or downgrade your subscription to Oddschecker+ at any time. Simply navigate to the ‘Manage
        Subscription’ section of your Oddschecker account and follow the steps via Stripe checkout. If you have any
        issues you can contact our team at <a href="mailto:support@oddschecker.com">support@oddschecker.com</a>.
      </>,
    ],
  },
  {
    heading: 'What happens at the end of my promo code period?',
    content: [
      'Any promo codes that were applied to your Oddschecker Unlimited subscription will be carried over to Oddschecker+ and run until originally stated. When signing up to Oddschecker+ Premium monthly you will receive 20% off (£96 saving) for 12 months, after which your subscription will auto-renew at £34.99 per month.',
    ],
  },
];
